module.exports = __webpack_public_path__ + "img/C12.b7929b68.svg";